module.exports = __webpack_public_path__ + "img/舒泰峰.e522b9ba.png";